import styled, { css } from 'styled-components';
import { absFull } from 'helpers/styles.js';
import arrowExportIcon from 'images/icons/arrow-export.png';
import { StyledTab } from '@bit/knotchinc.web-react-components.tabs';

export const TimeFilter = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-right: 24px;
  margin-bottom: 10px;
  color: #6994BB;

  &:hover {
    cursor: pointer;
  }

  ${({ selected, theme }) => selected && css`
    color: ${theme.colors.palette[6]};
    padding-bottom: 7px;
    border-bottom: 1px solid ${theme.colors.palette[6]};

    &:hover {
      cursor: default;
    }
  `}

  &:last-child {
    margin-right: 0;
  }
`;

export const Timestamp = styled.div`
  display: inline-block;
  position: absolute;
  right: ${({ right }) => right};
  text-align: ${({ textAlign }) => textAlign};
  font-size: 8px;
  line-height: 11px;
  letter-spacing: 1.5px;
  text-transform: uppercase;

  color: #6994BB;
`;

export const LeftSideBarWrapper = styled.div`
  float: left;
  display: block;
`;

export const ContentOverTimeContainer = styled.div`
  margin-left: 12px;
  height: 100%;
  vertical-align: top;
  display: inline-block;
  border-radius: 15px;
  color: white;
  padding: 40px;
  width: 26%;
  background: linear-gradient(6.02deg, #122333 -9.49%, #2B4F70 91.14%);

  @media (max-width: 1350px) {
    width: 28%;
  }
`;

export const TopDataOverlay = styled.div`
  background: linear-gradient(62.13deg, #0C1520 25.53%, rgba(12, 31, 44, 0.7) 67.18%, rgba(63, 78, 90, 0.25) 92.45%);
  border-radius: 15px;
  padding: 40px;
  ${absFull()};
`;

export const TopDataContainer = styled.div`
  position: relative;
  height: 100%;
  display: inline-block;
  border-radius: 15px;
  width: 73%;
  background: url('${({ background }) => background}') center center no-repeat;
  background-size: cover;

  @media (max-width: 1350px) {
    width: 70%;
  }
`;

export const ExportPDFButton = styled.div`
background: #2D8BFF;
border: 1px solid #2D8BFF;
box-sizing: border-box;
border-radius: 20px;
padding: 7px 14px 7px 30px;
color: white;
display: inline-block;
position: absolute;
right: 36px;
font-weight: bold;
font-size: 9px;
line-height: 13px;
letter-spacing: 2px;
cursor: pointer;

&:before {
  content: '';
  background: url('${arrowExportIcon}');
  width: 6px;
  height: 8px;
  position: absolute;
  top: 9px;
  left: 15px;
}
`;

export const InsightsTabContainer = styled.div`
  ${StyledTab} {
    width: 20%;
  }
`;
